import { render, staticRenderFns } from "./VarietyGrowth.vue?vue&type=template&id=3ce71cfa&scoped=true&"
import script from "./VarietyGrowth.vue?vue&type=script&lang=ts&"
export * from "./VarietyGrowth.vue?vue&type=script&lang=ts&"
import style0 from "./VarietyGrowth.vue?vue&type=style&index=0&id=3ce71cfa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce71cfa",
  null
  
)

export default component.exports